var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { REACT_APP__URL_SMP_API } from "@smp/utils";
import { apiRequest } from "../../../lib";
export class ApiSmpArtGalleryCrello {
}
_a = ApiSmpArtGalleryCrello;
/**
 * Used to create new CrelloDesign
 */
ApiSmpArtGalleryCrello.create = ({ design_id, export_url, }) => apiRequest({
    body: { design_id, export_url },
    endpoint: REACT_APP__URL_SMP_API + "/art-gallery/v1/crello/",
    method: "POST",
});
/**
 * Used to delete existing CrelloDesign by id
 */
ApiSmpArtGalleryCrello.destroy = ({ id, }) => apiRequest({
    endpoint: REACT_APP__URL_SMP_API + `/art-gallery/v1/crello/${id}`,
    method: "DELETE",
});
/**
 * Used to list existing CrelloDesigns
 */
ApiSmpArtGalleryCrello.list = () => __awaiter(void 0, void 0, void 0, function* () {
    return (yield apiRequest({
        endpoint: REACT_APP__URL_SMP_API + "/art-gallery/v1/crello/",
        method: "GET",
    })).results;
});
/**
 * Used to update existing CrelloDesign
 */
ApiSmpArtGalleryCrello.update = ({ design_id, export_url, id, }) => apiRequest({
    body: { design_id, export_url },
    endpoint: REACT_APP__URL_SMP_API + `/art-gallery/v1/crello/${id}`,
    method: "PUT",
});
//# sourceMappingURL=crello.js.map